import { Grid } from '@mui/material';
import styled from 'styled-components';

import * as S from 'commons/components/Table/Table.styles';

export const DialogHeader = styled(Grid)`
  background: #f5f5f5;
  padding: 16px 24px;
  color: #666;
`;

export const InfoRow = styled(Grid)`
  padding: 20px 24px 0 24px;
`;

export const CustomerRow = styled(Grid)`
  padding: 16px 24px 24px 24px;
  border-bottom: 1px solid #e0e0e0;
`;

export const TableWrapper = styled.div`
  overflow-y: auto;
  margin: 0 16px;
  padding: 16px 0;
`;

export const InfoLabel = styled.p`
  color: #6b7280;
  font-size: 12px;
  margin: 0;
`;

export const InfoValue = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin: 4px 0 0 0;
`;

export const StatusBadgeWrapper = styled.div`
  margin-top: 4px;
`;

export const StatusBadge = styled.span<{ $bg: string; $color: string }>`
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  border-radius: 4px;
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.5px;
`;

export const CapitalizedColumn = styled(S.TableColumn)`
  text-transform: capitalize;
`;
